import { Container, Stack, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import SearchLanguage from './components/SearchLanguage/SearchLanguage';
import SubmitButton from 'Global/Components/UnEditableComponents/SubmitButton/SubmitButton';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useData from './data/useData';
import LanguageCombo from './components/LanguageCombo/LanguageCombo';
import useLogic from './logic/useLogic';
import useCreateComplexField from 'Global/Hooks/useCreateComplexField';
import useOptimizedSearchList from 'Global/Hooks/useOptimizedSearchList/useOptimizedSearchList';
import Words from './components/Words/Words';
import { UpdateWordList } from './Adapters/UpdateWordList';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const LanguageEditor = ({
  setShowLangEditor,
  closeEdtiorLabel,
}) => {
  const [forceRender, setForceRender] = useState(false);
  const data = useData(forceRender);
  const { fields, control, formState, handleSubmit } =
    useCreateComplexField(`words`, data?.words);

  const submitMsg = FindLangKey('general-public-btn-save');
  useLogic();
  const { listHandlers } = useOptimizedSearchList(
    fields,
    15,
    'Id'
  );

  useEffect(() => {
    setForceRender((prev) => !prev);
    setForceRender((prev) => !prev);
  }, []);

  return (
    <React.Fragment>
      <Container>
        <Stack gap=".5em" marginTop={'1em'}>
          <SearchLanguage />
          <LanguageCombo
            options={data.languageOptions}
            initialLanguage={data.initialLang}
          />
          <form
            onSubmit={handleSubmit((data) => {
              // const pairedData = data?.words
              //   ?.map((word) =>
              //     word?.Value?.length > 0 && word?.Key?.length > 0
              //       ? {
              //           ...word,
              //           Value: word?.Value,
              //         }
              //       : word
              //   )
              //   .filter((fl) => fl.Value !== undefined);
              console.log('pairedData->', data);
              UpdateWordList(data?.words, setForceRender);
            })}
          >
            <Stack direction="row-reverse" gap=".5em">
              <SubmitButton label={submitMsg} />
              <Button
                variant="contained"
                sx={{
                  color: `${themeColors.ColorPrimary} !important`,
                  maxHeight: '40px',
                }}
                onClick={() => {
                  setShowLangEditor(false);
                }}
                fullWidth
              >
                {closeEdtiorLabel}
              </Button>
            </Stack>
            <Stack gap=".5em" marginTop={'1em'}>
              <Words
                {...{ listHandlers, control, formState }}
              />
            </Stack>
          </form>
        </Stack>
      </Container>
    </React.Fragment>
  );
};

export default LanguageEditor;
